import { FolderOpenRounded, SystemUpdateAltRounded } from "resource/muiImport"
import { Box, Button, Dialog, DialogContent, Divider, TextField, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { BoxFC, BoxFR } from "components/BoxCustom"
// import ComboBox from "components/ComboBox"
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { shipmentApiNm, initDialogData, shipmentColNm } from "constants/shipmentConstant"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import useCompactLayout from "hooks/useCompactLayout"
import PhotoCameraRounded from "@mui/icons-material/PhotoCameraRounded"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import isFileOverSize from "utils/isFileOverSize"
import CustomerDialog from "pages/Menu2/CustomerManagement/CustomerDialog"

const initReadFileDialogData = {
  ...initDialogData,
  CneeNm: "",
  CneeAddr: "",
  Vol: [],
  VolStr: "",
  ShpmTyp: "EX",
  ContNosStr: "",
  KGM: "",
  M3: "",
  CT: "",
  ContNos: [],
}
const ReadBLDialog = ({ dialogOpen, setDialogOpen, onFinish }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const isCompact = useCompactLayout()
  const [dialogData, setDialogData] = useState({ ...initReadFileDialogData })
  const [fileName, setFileName] = useState("")
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileUrl, setFileUrl] = useState(null);
  const [dialogCusOpen, setDialogCusOpen] = useState(false)

  // const shpmTypId = useMemo(() => {
  //   return dialogData.ShpmTyp === "EX" ? 1 : 2
  // }, [dialogData.ShpmTyp])

  const textFieldProps = useCallback((name) => ({
    size: "small",
    label: shipmentColNm[name],
    value: dialogData[name],
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value }))
  }), [dialogData])

  const dateTimePickerProp = useCallback((name) => ({
    label: shipmentColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: dialogData[name],
    onChange: (newValue) => { setDialogData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} />,
  }), [dialogData])

  const handleSelectFile = useCallback((e) => {
    const file = e.target.files[0]
    if (isFileOverSize(file)) return

    setSelectedFile(file)
    setFileName(file.name)
    // const pdfFiles = data.Files
    // .filter(file => file.ShpFileTypId === 2)
    // .map(file => `/file/shipping/${nowShpInvId}/${file.FileNm}`)
    // setPdfData(pdfFiles)

  }, [])

  const handleUploadFile = useCallback(async () => {
    const data = new FormData();
    data.append("file", selectedFile);
    // const result = await ax.post(shipmentApiNm.uploadReadFile, data)


    ax.post(shipmentApiNm.uploadReadBLFile, data).then(value => {
      if (value.data) {
        const cneeNm = value.data.CneeNm.trim().toLowerCase()
        // console.log("cneeNm", cneeNm)
        const found = msData.customers.find(c => c.Name?.trim()?.toLowerCase() === cneeNm)
        // console.log("found", found)
        // console.log("cneeAddr:: ", value.data.CneeAddr)
        setDialogData(o => ({
          ...o,
          ...value.data,
          CneeId: found ? found.CusId : o.CneeId,
          ContNosStr: value.data.ContNos.join(", "),
        }))
      }
    })


  }, [ax, selectedFile, msData.customers])

  // console.log("Selected file in ReadBLDialog dialogData::", dialogData)
  /**
   * have to remove TakePlc and RtnPlc coz it has proble when set TakePOIId to null old code will show TakePlc
   */
  const handleDialogOk = useCallback(() => {
    onFinish({
      ...dialogData,
      file: selectedFile
    })
    setDialogOpen(false)
  }, [onFinish, setDialogOpen, dialogData, selectedFile])


  const handleDragOver = useCallback((e) => {
    /** Must prevent the can use onDrop */
    e.preventDefault()
  }, [])
  const handleDropFile = useCallback((e) => {

    e.preventDefault()
    let files = []
    if (e.dataTransfer.items) {
      if (e.dataTransfer.items.length > 0 && e.dataTransfer.items[0].kind === 'file') {
        files = Array.from(e.dataTransfer.items).map(item => item.getAsFile())
      } else {
        return
      }
    } else {
      if (e.dataTransfer.files.length > 0) {
        files = Array.from(e.dataTransfer.files)
      } else {
        return
      }
    }

    for (const file of files) {
      if (isFileOverSize(file)) return

      // const fileNameOnly = file.name.substring(0, file.name.lastIndexOf('.')) || file.name
      file.label = file.name
      file.imgLink = URL.createObjectURL(file)
    }

    setFileName(files[0].name)
    setSelectedFile(files[0])
  }, [setSelectedFile])


  const handlePaste = useCallback((e) => {
    const items = e.clipboardData.items;
    for (const item of items) {
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        // setFileData(file);
        setSelectedFile(file);
        // setPreviewSrc(URL.createObjectURL(file));
        break;
      }
    }
  }, []);

  // const handleAddConsignee = useCallback(() => {
  //   setDialogCusOpen(true)
  // }, [])

  const onDialogCusFinish = useCallback((id) => {
    setDialogData(o => ({ ...o, CneeId: id }))
  }, [])

  const customerDialogPropsMemo = useMemo(() => {
    return {
      state: {
        dialogOpen: dialogCusOpen,
        selectedCusId: 0,
        Name: dialogData.CneeNm,
        Addr: dialogData.CneeAddr
      },
      fn: {
        setDialogOpen: setDialogCusOpen,
        onFinish: onDialogCusFinish
      }
    }
  }, [dialogCusOpen, onDialogCusFinish, dialogData.CneeNm, dialogData.CneeAddr])

  useEffect(() => {
    document.addEventListener('paste', handlePaste);
    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, [handlePaste]);

  useEffect(() => {
    if (!dialogOpen) {
      setFileName("")
      setSelectedFile(null)
      setDialogData({ ...initReadFileDialogData })
    }
  }, [dialogOpen, ax])

  /**
   * prevent preview blink if loaded pdf
   */
  useEffect(() => {
    if (selectedFile) {
      const url = URL.createObjectURL(selectedFile);
      setFileUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [selectedFile]);

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={isCompact ? undefined : PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='lg' fullScreen={isCompact}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="อ่านข้อมูลจากไฟล์"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFR pt={2} height={isCompact ? "auto" : 730} sx={{ alignItems: "stretch", flexDirection: isCompact ? "column" : "row" }}>
          <BoxFC width={isCompact ? "100%" : 380} sx={{ gap: 1 }}>
            <BoxFR>
              <TextField size="small" label="ชื่อไฟล์" fullWidth value={fileName} />
              <Button variant="contained" component="label">
                <input type="file" hidden onChange={handleSelectFile} />
                <FolderOpenRounded />
              </Button>
              {isCompact ?
                <Button variant="contained" component="label" aria-label="ถ่ายรูปเอกสาร">
                  <input type="file" hidden accept="image/*" capture="environment" onChange={handleSelectFile} />
                  <PhotoCameraRounded />
                </Button> : null}
            </BoxFR>
            <Button size="small" variant="contained" fullWidth onClick={handleUploadFile}>ดึงข้อมูล</Button>
            <Divider />
            <TextField {...textFieldProps("Bkg")} label="B/L No." />
            <TextField {...textFieldProps("CneeNm")} label="Consignee" />
            <TextField {...textFieldProps("CneeAddr")} label="Consignee Address" multiline rows={3} />
            {/* <BoxFR>
              <ComboBox sx={{ flex: 1 }} options={msData.cusCombo} label={shipmentColNm.Cnee}
                selectedId={dialogData.CneeId}
                setSelectedId={(id) => setDialogData(o => ({ ...o, CneeId: id }))}
              />
              <Button variant="contained" onClick={handleAddConsignee}><AddCircleRounded sx={{ mr: 1 }} /> เพิ่ม Consignee</Button>
            </BoxFR> */}
            <DateTimePickerCustomTime {...dateTimePickerProp("ETA")} />
            <BoxFR>
              <TextField {...textFieldProps("Vssl")} />
              <TextField {...textFieldProps("Voy")} />
            </BoxFR>
            <BoxFR>
              <TextField {...textFieldProps("Agnt")} />
              <TextField {...textFieldProps("Port")} />
            </BoxFR>
            <BoxFR>
              <TextField {...textFieldProps("KGM")} label="KGM" />
              <TextField {...textFieldProps("CT")} label="CT" />
              <TextField {...textFieldProps("M3")} label="M3" />
            </BoxFR>
            <TextField {...textFieldProps("VolStr")} label="Volume" />
            <TextField {...textFieldProps("ContNosStr")} label="Container No(s)." multiline rows={4} />
          </BoxFC>
          <BoxFC sx={{ gap: 0, ...(isCompact && !selectedFile ? { display: "none" } : {}) }} width={isCompact ? "100%" : 700} height={isCompact ? 320 : "100%"} p={1} border="1px solid lightgrey"
            borderRadius={2} bgcolor="white" onDrop={handleDropFile} onDragOver={handleDragOver}>
            {selectedFile ? (
              <Box
                component="iframe"
                src={fileUrl}
                width="100%"
                height="100%"
              //onLoad={() => URL.revokeObjectURL(selectedFile)}

              />
            ) : (
              <BoxFC sx={{ gap: 0 }} justifyContent="center" alignItems="center" width="100%" height="100%">
                <SystemUpdateAltRounded sx={{ fontSize: 50, color: grey[500] }} />
                <Typography variant="h6" sx={{ color: grey[500] }}>Drop file here</Typography>
                <Typography variant="h6" sx={{ color: grey[500] }}>Or</Typography>
                <Typography variant="h6" sx={{ color: grey[500] }}>Paste image from clipboard</Typography>
              </BoxFC>
            )}
          </BoxFC>
        </BoxFR>

        <CustomerDialog {...customerDialogPropsMemo} />
      </DialogContent>
      <DialogFooter okText={"ใส่ข้อมูลในใบแจ้งลาก"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(ReadBLDialog)